import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { signOut } from "firebase/auth";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as AddDocument } from "../../assets/svg/add-document.svg";
import { ReactComponent as HistoryDocument } from "../../assets/svg/history-document.svg";
import { ReactComponent as User } from "../../assets/svg/user.svg";
import NavCard from "../../components/navCard/NavCard";
import { unsetUser } from "../../features/auth/authSlice";
import { auth } from "../../utils/firebase/firebase";
import { exportData, getCollectionData } from "../../utils/variables";

const navOptions = [
  {
    icon: <AddDocument />,
    text: "Start with a clean table",
    buttonText: "Create a new file",
    link: "new",
  },
  {
    icon: <HistoryDocument className="w-55" />,
    text: "Open a previously saved file",
    buttonText: "Load an existing file",
    link: "last",
  },
  {
    icon: <HistoryDocument className="w-55" />,
    text: "Manage your existing field in your storage",
    buttonText: "Open files",
    link: "manage/files",
  },
  // {
  //   icon: <IoMdSettings />,
  //   text: "Adjust your preferences and other settings",
  //   buttonText: "Open Settings",
  //   link: "settings",
  // },
  {
    icon: <User className="primary-color" />,
    text: "Access your account and security settings",
    buttonText: "Manage Account",
    link: "account",
  },
  // {
  //   icon: <Logout className="primary-color" />,
  //   text: "Exit the app",
  //   buttonText: "Logout",
  // },
];

const Home = () => {
  const { firstName, isActive } = useSelector((state) => state.auth);
  const test = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  // console.log(test);
  const handleLogout = async (e) => {
    try {
      // console.log("Logging Out");
      await signOut(auth);
      dispatch(unsetUser());
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleClick = async () => {
    // Replace '/target' with the URL you want to redirect to
    const config = await getCollectionData("Configs", "Variables");

    window.location.href = config?.homeMenu?.membershipRedirect;
  };

  const handleExport = async () => {
    const config = await exportData();
  };

  return (
    <>
      {isActive ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            minHeight: "100vh",
            margin: "auto",
            maxWidth: { lg: "1200px", sm: "610px", xs: "300px" },
            padding: "0 20px",
          }}
        >
          <h2
            style={{
              marginBottom: "20px",
              fontSize: "2em",
              fontWeight: "800",
              color: "var(--faded-text)",
            }}
          >
            Welcome, {firstName}!
          </h2>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {navOptions.map((nav) => {
              return (
                <NavCard
                  key={nav.text}
                  icon={nav.icon}
                  text={nav.text}
                  buttonText={nav.buttonText}
                  link={nav.link}
                />
              );
            })}
          </Box>

          {/* <Button
            onClick={handleExport}
            variant="text"
            sx={{
              fontWeight: "800",
              color: "var(--faded-text)",
              fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;" `,
              textTransform: "none",
            }}
          >
            Export Data
          </Button> */}

          <Button
            onClick={handleLogout}
            variant="text"
            sx={{
              fontWeight: "800",
              color: "var(--faded-text)",
              fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;" `,
              textTransform: "none",
            }}
          >
            Logout
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            minHeight: "100vh",
            margin: "auto",
            maxWidth: { lg: "1200px", sm: "610px", xs: "300px" },
            padding: "0 20px",
          }}
        >
          <h2
            style={{
              marginBottom: "40px",
              fontSize: "2em",
              fontWeight: "800",
              color: "var(--faded-text)",
            }}
          >
            It seems that your subscription has expired Please contact our
            support staff to continue using your account.
          </h2>
          <Button
            onClick={handleClick}
            variant="contained"
            size="large"
            sx={{
              fontWeight: "800",
              fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;" `,
              textTransform: "none",
            }}
            width="50%"
          >
            Contact Tuos
          </Button>
          <br />
          <Button
            onClick={handleLogout}
            // variant="text"
            variant="outlined"
            size="large"
            sx={{
              fontWeight: "800",
              // color: "var(--faded-text)",
              fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;" `,
              textTransform: "none",
            }}
            width="50%"
          >
            Logout instead
          </Button>
        </Box>
      )}
    </>
  );
};

export default Home;
